export default {
  sidebarWidth: '30%',
  sidebarWidthTablet: '52px',
  drawerWidthDesktop: '400px',
  drawerWidthTablet: '320px',
  drawerHeightPhone: '250px',
  filterFormWidth: '160px',
  eventsDrawerWidth: '320px',
  bottomBarHeight: 56,
  popupMapOffset: 300,
  popupMaxWidth: 288,
  popupImageHeight: 144,
};
